module.exports = __webpack_public_path__ + "img/YEDC.0bda261d.svg";